import { DateField, RichTextField, Show, SimpleShowLayout, TextField } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";



export function ContestShow(props) {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="name" />
                <RichTextField source="description" />
                <DateField source="startDate" showTime />
                <DateField source="endDate" showTime />
                <TextField source="type" />
                <TextField source="location" />
                <TextField source="googleMapsLink" />
                <TextField source="googleFormLink" />
                <TextField source="organizerName" />
                <TextField source="organizerEmail" type="email" />
                <TextField source="organizerPhone" />
                <FileInput source="images" title="Uploaded Files" route="contest/upload" />

                <RichTextField source="rules" />
                <RichTextField source="prizes" />
                <RichTextField source="terms" />
            </SimpleShowLayout>
        </Show>
    )
}